import {
  INVOICE_STATUS_APPROVED_BY_SET,
  INVOICE_STATUS_CANCELLATION_FAILED,
  INVOICE_STATUS_CANCELLATION_REQUESTED,
  INVOICE_STATUS_CANCELLED,
  INVOICE_STATUS_CHOICES,
  INVOICE_STATUS_DRAFT,
  INVOICE_STATUS_DRAFT_DISCARDED,
  INVOICE_STATUS_ERROR,
  INVOICE_STATUS_NOMINATED,
  INVOICE_STATUS_RECOVERABLE_ERROR,
  INVOICE_STATUS_RESEND_REQUESTED,
  INVOICE_STATUS_SET_UNKNOWN_ERROR,
  INVOICE_STATUS_UPLOADED_TO_SET,
} from "../../models/invoice";

interface ElectronicDocumentStatusBadgeProps {
  status?: string;
}

// All electronic document types (invoices, credit/debit/remission notes,
// auto-invoices, receipts) share the same SET status vocabulary, so the badge
// colors and labels mirror the per-entity *CrudStatus components.
const badgeClassNameForStatus = (status?: string): string => {
  switch (status) {
    case INVOICE_STATUS_UPLOADED_TO_SET:
    case INVOICE_STATUS_RESEND_REQUESTED:
      return "badge-warning";
    case INVOICE_STATUS_ERROR:
    case INVOICE_STATUS_RECOVERABLE_ERROR:
    case INVOICE_STATUS_SET_UNKNOWN_ERROR:
    case INVOICE_STATUS_CANCELLATION_FAILED:
      return "badge-danger";
    case INVOICE_STATUS_APPROVED_BY_SET:
    case INVOICE_STATUS_NOMINATED:
      return "badge-success";
    case INVOICE_STATUS_CANCELLATION_REQUESTED:
      return "badge-light";
    case INVOICE_STATUS_DRAFT:
      return "badge-secondary";
    case INVOICE_STATUS_DRAFT_DISCARDED:
      return "badge-dark";
    case INVOICE_STATUS_CANCELLED:
    default:
      return "badge-info";
  }
};

const ElectronicDocumentStatusBadge: React.FC<
  ElectronicDocumentStatusBadgeProps
> = ({ status }) => {
  if (!status) {
    return <>-</>;
  }

  const label = INVOICE_STATUS_CHOICES.get(status) || status;

  return (
    <span
      className={`badge badge-pill ${badgeClassNameForStatus(status)}`}
      style={{ fontSize: "14px" }}
    >
      {label}
    </span>
  );
};

export default ElectronicDocumentStatusBadge;
